module.exports = __webpack_public_path__ + "img/Cutaways_house_3_tile.89ea974a.jpg";